import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsStacked02 = function CoinsStacked02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 5c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m11 0v4.4572c-1.2215.3668-2 .9217-2 1.5428M2 5v12c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571V11M2 9c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571M2 13c0 1.1046 2.4624 2 5.5 2 1.3296 0 2.5491-.1716 3.5-.4571M22 11c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2m11 0c0-1.1046-2.4624-2-5.5-2s-5.5.8954-5.5 2m11 0v8c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2v-8m11 4c0 1.1046-2.4624 2-5.5 2s-5.5-.8954-5.5-2"
    })
  }));
};
export default CoinsStacked02;